import { render, staticRenderFns } from "./payee_detail.vue?vue&type=template&id=8b2243d8&scoped=true"
import script from "./payee_detail.vue?vue&type=script&lang=js"
export * from "./payee_detail.vue?vue&type=script&lang=js"
import style0 from "./payee_detail.vue?vue&type=style&index=0&id=8b2243d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2243d8",
  null
  
)

export default component.exports